import styled from '@emotion/styled';
import { Avatar, Divider, Switch } from '@mui/material';

export const AuthTypeSwitch = styled(Switch)({
    marginLeft: 35,
});
AuthTypeSwitch.defaultProps = {
    color: 'success',
};

export const DividerWrapper = styled(Divider)({
    height: '1rem',
    marginBottom: '1rem',
});

export const AvatarWrapper = styled(Avatar)({
    fontSize: '0.75rem',
    height: '1.25rem',
    width: '1.25rem',
    marginRight: '0.3rem',
});
